<template>
  <v-main>
    <!-- / Mini Variant Sidebar -->
    <v-container fluid>
      <div class="dj-page-head">
        <div class="dj-page-head__text dj-page-head__row">
          <backbutton></backbutton>
          <h1 class="dj-page-title">Users</h1>
        </div>
        <div class="dj-page-actions">
          <v-btn fab small depressed color="primary" to="/users/create">
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </div>
      </div>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Is Active</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, i) in users" :key="user.name">
                    <td>{{ i + 1 }}</td>
                    <td>{{ user.first_name }} {{ user.last_name }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.is_active == true ? "Yes" : "No" }}</td>
                    <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/users/${user.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
export default {
  components: { backbutton },
  name: "UsersPage",
  data() {
    return {
      users: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let users = await axios.get(`users?role_id=6`);
      this.users = users.data.data;
      this.isLoading = false;
    },
  },
};
</script>
